"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
    "ja": {
        "translation": {
            "global_navigation": {
                "navigation_items": {
                    "logo": "Launchpad に戻る",
                    "app_switcher": "アプリを切り替える",
                    "announcer": "発表",
                    "helper": "ヘルプとサポート",
                    "user": "サインイン: {{username}}",
                    "user_with_customer": "{{username}} {{customerName}}",
                    "sign_in": "サインイン"
                },
                "apps": {
                    "academy": "アカデミー",
                    "community": "コミュニティ",
                    "projects": "プロジェクト",
                    "results": "リザルト",
                    "storyboards": "ストーリーボード",
                    "mission_control": "ミッション コントロール",
                    "risks": "ストラテジー",
                    "reports": "レポート",
                    "launchpad": "Launchpad",
                    "robots": "ロボット",
                    "frameworks": "フレームワーク",
                    "compliance_maps": "コンプライアンス マップ",
                    "assurance_plans": "保証計画",
                    "project_scheduler": "スケジューラ",
                    "issue_tracker": "問題の追跡ツール",
                    "task_tracker": "タスクの追跡ツール",
                    "project_timesheets": "タイムシート",
                    "dashboard": "{{module}}ダッシュボード",
                    "master_library": "マスター ライブラリ"
                },
                "app_sections": {
                    "setup": "セットアップ",
                    "workspace": "ワークスペース",
                    "automation": "自動化"
                },
                "user": {
                    "my_profile": "マイ プロファイル",
                    "log_out": "ログアウト"
                },
                "helper": {
                    "help_docs": "ヘルプ ドキュメント",
                    "support": "サポート"
                },
                "skip_button": "メイン コンテンツまでスキップ",
                "logo": "ロゴ",
                "other": "その他",
                "section": "セクション"
            }
        }
    }
};
exports.default = locales;
//# sourceMappingURL=ja.js.map